<template>
  <modal v-show="internalShow">
    <h4 class="modal-title" slot="header-text">{{ row.part_name }}</h4>

    <div class="modal-body" slot="modal-body">
      <div class="form-group">
        <label class="text-bold">{{ $t('modalcomment.comment') }}</label>

        <textarea
          v-model="activePartComment"
          class="form-control"
          rows="5"
          type="text"
          :disabled="PartModalLoading"
          :class="{'parsley-error': errors.part_comment}"
        ></textarea>

        <ul class="parsley-errors-list filled" v-if="errors.part_comment">
          <li class="parsley-required">{{ errors.part_comment[0] }}</li>
        </ul>
      </div>
    </div>

    <div slot="modal_buttons">
      <button
        class="btn btn-secondary"
        type="button"
        :disabled="PartModalLoading"
        @click="close_modal"
      >{{ $t('modal.close') }}
      </button>

      <button
        class="btn btn-outline-success ml-1"
        type="button"
        :disabled="PartModalLoading"
        @click="save_part_comment"
      >{{ $t('modalcomment.save') }}
      </button>
    </div>
  </modal>
</template>

<script>
import api from '@/api'
import Modal from '@/components/Modal.vue'
import message from '@/message'

export default {
  name: 'PartCommentModal',

  components: {
    modal: Modal
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      PartModalLoading: false,
      activePartComment: '',
      errors: {
        part_comment: undefined
      },
    }
  },

  computed: {
    internalShow: {
      get() {
        return this.show
      },
      set(value) {
        this.$emit('update:show', value)
      }
    }
  },

  watch: {
    show(value) {
      if (value) {
        this.activePartComment = this.row.part_comment
      }
    }
  },

  methods: {
    close_modal() {
      if (this.PartModalLoading) return;

      this.internalShow = false
      this.activePartComment = ''
      this.errors['part_comment'] = undefined
    },
    save_part_comment() {
      if (this.PartModalLoading) return;

      this.errors['part_comment'] = undefined

      let comment = this.activePartComment.trim()

      if (comment.length > 2000) {
        this.errors['part_comment'] = [this.$i18n.t('add_comment.comment-cant-be-longer-2000-chars')]
        return
      }

      this.PartModalLoading = true

      api.patch(`/parts/${this.row.part}/`, {
        comment: comment
      })
        .then(response => {
          this.row.part_comment = response.data.comment
          message.success(this.$i18n.t('add_comment.supplier-comment-added'))
          this.PartModalLoading = false
          this.close_modal()
        })
        .catch(error => {
          message.error(this.$i18n.t('message-errors.error'))
          this.PartModalLoading = false
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PartCommentModal.vue